import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Card, CardBody, Input, Button, Table, FormGroup, Label, UncontrolledDropdown, DropdownToggle, DropdownMenu, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string'
import moment from "moment";
import { toast } from 'react-toastify';
import { cloneDeep, filter, isEmpty, isNil, startsWith } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import noImage from '../../assets/images/users/no-img.jpg';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import NavTab from '../../components/NavTab';
import { baseUrl } from '../../constants/environment';
import styled from 'styled-components';
import TextUtils from '../../helpers/TextUtils';
import { MySelectLoading } from '../../helpers/SelectAsync';
import ToggleButton from '../../common/ToggleButton';
import UserManager from '../../manager/UserManager';
import PhoneImageIcon from '../../assets/images/icon-phone.png';
import SupplierTab from './components/SupplierTab';
import ReceiptsAdd from '../receipts/ReceiptsAdd';
import PaymentAdd from '../payment/PaymentAdd';

const configPage = {
    titlePage: 'Thêm hồ sơ nhà cung cấp',
    pathPage: '/supplier',
    column: 10,
}

interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}

const SourceList:any = [
    {
        value:1,
        label: "Nguồn tự tìm kiếm",
    },
    {
        value:2,
        label: "Nguồn tự phát triển",
    },
    {
        value:3,
        label: "Nguồn Marketing",
    },
    {
        value:4,
        label: "Nguồn Facebook ads",
    },
    {
        value:5,
        label: "Nguồn Zalo",
    },
    {
        value:6,
        label: "Nguồn Tiktok",
    },
    {
        value:7,
        label: "Nguồn Website",
    },
    {
        value:8,
        label: "Nguồn landing page",
    },
    {
        value:9,
        label: "Nguồn Google",
    },
    {
        value:10,
        label: "Nguồn Youtube",
    },
    {
        value:11,
        label: "Nguồn resales",
    },
    {
        value:12,
        label: "Nguồn app",
    },
    {
        value:13,
        label: "Nguồn nhà cung cấp BOD",
    },
]

const RelationList = [
    {
        value:'father',
        label: "Cha",
    },
    {
        value:'mother',
        label: "Mẹ",
    },
    {
        value:'grandfather',
        label: "Ông",
    },
    {
        value:'Grandmother',
        label: "Bà",
    },
    {
        value:'olderbrother',
        label: "Anh trai",
    },
    {
        value:'brother',
        label: "Em trai",
    },
    {
        value:'youngersister',
        label: "Em gái",
    },
    {
        value:'other',
        label: "Khác",
    },
]

const List = (props: any) => {
    const {from,dataFromExam, setDataFromExam, closeModal, fetchCustomerExam} = props
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(props?.match?.params?.id);
    const [onlyView, setOnlyView] = useState(false);
    const [data, setData] = useState({
        status: 1
    });
    const [modalIsOpen, setIsOpen] = useState(false);
    const [type, setType] = useState(props?.match?.params?.action);
    const [action, setAction] = useState<any>();
    const [province, setProvince] = useState<any>([]);
    const [district, setDistrict] = useState<any>([]);
    const [ward, setWard] = useState<any>([]);

    useEffect(() => {
        if (id && id !== 'add') {
            loadData(id)
            document.title = 'Chỉnh sửa nhà cung cấp'
            
        }else{
            document.title = 'Thêm mới nhà cung cấp'
        }
        if (type === 'view') {
            setOnlyView(true)
            document.title = 'Chi tiết nhà cung cấp'
        }
    }, [id]);
    

    useEffect(() => {
        fetchProvince()
    }, []);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const fetchProvince = async () => {
        const url = `${baseUrl}/address/provinces`;
        const params = {
            page:1,
            limit: 100,
        }
        let response: any = await APIClient.GET(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response?.data !== undefined) {
            let ListArr:any = [];
            response.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: Number(e?.code),
                    label: e?.name
                })
            })
            setProvince(ListArr)
        }
    }

    const fetchDistrict = async (province_code:any) => {
        const url = `${baseUrl}/address/districts`;
        const params = {
            page:1,
            limit: 500,
            province_code: province_code
        }
        let response: any = await APIClient.GET(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response?.data !== undefined) {
            let ListArr:any = [];
            response.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: Number(e?.code),
                    label: e?.name
                })
            })
            setDistrict(ListArr)
        }
    }

    const fetchWard = async (district_code:any) => {
        const url = `${baseUrl}/address/wards`;
        const params = {
            page:1,
            limit: 500,
            district_code: district_code
        }
        let response: any = await APIClient.GET(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response?.data !== undefined) {
            let ListArr:any = [];
            response.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: Number(e?.code),
                    label: e?.name
                })
            })
            setWard(ListArr)
        }
    }

    const loadData = async (id:number) => {
        const url = `${baseUrl}/supplier/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            fetchDistrict(resData?.provinces_code?.code);
            fetchWard(resData?.district_code?.code)
            const dataTemp:any = {
                ...resData,
                provinces_code: {value: resData?.provinces_code?.code, code: resData?.provinces_code?.code, label: resData?.provinces_code?.name},
                district_code:{value: resData?.district_code?.code, code: resData?.district_code?.code, label: resData?.district_code?.name},
                wards_code:{value: resData?.wards_code?.code, code: resData?.wards_code?.code, label: resData?.wards_code?.name},
            }
            setData(dataTemp)
        }
    }

    return (
        <div style={{paddingBottom:50}}>
            <React.Fragment>
                {
                    !from &&
                    <PageTitle
                        breadCrumbItems={[
                            { label: `${type == 'view' ? 'Xem chi tiết' : id ? 'Chỉnh sửa' : 'Thêm mới'} hồ sơ nhà cung cấp`, active: true },
                        ]}
                        title={`${type == 'view' ? 'Xem chi tiết' : id ? 'Chỉnh sửa' : 'Thêm mới'} hồ sơ nhà cung cấp`}
                    />
                }
                <ContentPage 
                    user={props?.user}
                    data={data}
                    setData={(val:any) => setData(val)}
                    province={province}
                    district={district}
                    ward={ward}
                    fetchDistrict = {(val:any) => fetchDistrict(val)}
                    fetchWard = {(val:any) => fetchWard(val)}
                    onlyView={onlyView}
                    id={id}
                    type={type}
                    action={action}
                    handleActionModal={(data:any) => handleActionModal(data)}
                    from={from}
                    closeModal={closeModal}
                    fetchCustomerExam={fetchCustomerExam}
                />
                <ModalPopup
                    isOpen={modalIsOpen}
                    onRequestClose={() => setIsOpen(false)}
                >
                    
                    {action?.type === 'addReceipts' ?
                        <ReceiptsAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} supplier_id={id} />:
                    action?.type === 'addPayment' ?
                        <PaymentAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} supplier_id={id} />:
                        <RenderActionModal closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} />
                    }
                </ModalPopup>
                {loading && <Loader />}
            </React.Fragment>
        </div>
    );
};

const ContentPage = (props:any) => {
    const {data,type, setData, fetchDistrict, fetchWard, province, district, ward, onlyView, id, action, handleActionModal, 
    from} = props
    const [loading, setLoading] = useState(false)
    const router = useHistory()
    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone" || name === "guardian_phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        if(value?.length > 1000) return;
        setData({
            ...data,
            [name]: value
        })
    }

    const validationFrom = () => {

        if (isEmpty(data.name)) {
            toast.warning('Tên nhà cung cấp không được để trống!');
            return false
        }
        if (isEmpty(data.phone)) {
            toast.warning('Số điện thoại không được để trống!');
            return false
        }
        if (
            (!TextUtils.validatePhone(data.phone)) || data.phone?.length > 11
        ) {
            toast.warning('Số điện thoại không đúng!');
            return false
        }
        if (!data.provinces_code) {
            toast.warning('Tỉnh/ Thành phố không được để trống!');
            return false
        }
        if (!data.district_code) {
            toast.warning('Quận/ Huyện không được để trống!');
            return false
        }
        if (!data.wards_code) {
            toast.warning('Phường/ Xã không được để trống!');
            return false
        }
        if (isEmpty(data.street)) {
            toast.warning('Địa chỉ chi tiết không được để trống!');
            return false
        }
        return true
    }
    
    const handleSubmit = async() => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/supplier`;
        const params = {
            ...data,
            provinces_code: data?.provinces_code?.code,
            district_code: data?.district_code?.code,
            wards_code: data?.wards_code?.code,
        }
        
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo mới nhà cung cấp thành công')
            router?.push('/supplier/list')
        }
    }

    const handleEdit = async() => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/supplier/${id}`;
        const params = {
            ...data,
            provinces_code: data?.provinces_code?.code,
            district_code: data?.district_code?.code,
            wards_code: data?.wards_code?.code,
        }
        
        delete params?.created_uid;
        delete params?.created_time;
        delete params?.id;
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Chỉnh sửa nhà cung cấp thành công')
            router?.push('/supplier/list')
        }
    }

    return (
        <PageContent style={from=='exam' ? {width:'900px', maxHeight:'80vh', overflowX:'hidden'}: {}} className={onlyView ? 'only-view' : ''}>
            <PageBody>
                <div className="nutri-title mb-3">Thông tin nhà cung cấp</div>
                <Row>
                    
                    <Col md={6} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label><span>*</span>Tên nhà cung cấp</Label>
                            <Input type="text" value={data?.name} onChange={(e: any) => handleChangeInput(e)} name="name" placeholder="Nhập tên nhà cung cấp" />
                        </FormGroup>
                    </Col>
                    <Col md={3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label>Mã nhà cung cấp</Label>
                            <Input type="text" value={data?.code} onChange={(e: any) => handleChangeInput(e)} name="code" placeholder={(type=='view' && !data?.code) ? "---" : "Nhập mã nhà cung cấp"} />
                        </FormGroup>
                    </Col>
                    
                    <Col md={3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label><span>*</span> Số điện thoại</Label>
                            <InputGroup>
                                <Input type="text" value={data?.phone} onChange={(e: any) => handleChangeInput(e)} name="phone" placeholder="Nhập số điện thoại" />
                                {
                                    type!='view' &&
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                        <img src={PhoneImageIcon} width={18} height={18} alt=""/>
                                    </InputGroupAddon>
                                }
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={from == 'exam' ? 4 : 3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label><span>*</span>Tỉnh/ Thành phố</Label>
                            <Select
                                placeholder="Chọn Tỉnh/ Thành phố"
                                className="react-select mb-2"
                                classNamePrefix="react-select"
                                isDisabled={onlyView}
                                onChange={(val: any) => {
                                    setData({ ...data, provinces_code: val, district_code: null, wards_code: null })
                                    fetchDistrict(val?.code);
                                }}
                                value={province?.filter(
                                    (option: any) => data?.provinces_code?.code == option.value
                                )}
                                options={province}
                            ></Select>
                        </FormGroup>
                    </Col>
                    <Col md={from == 'exam' ? 4 : 3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label><span>*</span>Quận/ Huyện</Label>
                            <Select
                                placeholder="Chọn Quận/ Huyện"
                                className="react-select mb-2"
                                classNamePrefix="react-select"
                                isDisabled={onlyView}
                                onChange={(val: any) => {
                                    setData({ ...data, district_code: val, wards_code: null })
                                    fetchWard(val?.code);
                                }}
                                value={district?.filter(
                                    (option: any) => data?.district_code?.code == option.value
                                )}
                                options={district}
                            ></Select>
                        </FormGroup>
                    </Col>
                    <Col md={from == 'exam' ? 4 : 3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label><span>*</span>Phường/ Xã</Label>
                            <Select
                                placeholder="Chọn Phường/ Xã"
                                className="react-select mb-2"
                                classNamePrefix="react-select"
                                isDisabled={onlyView}
                                onChange={(val: any) => {
                                    setData({ ...data, wards_code: val})
                                }}
                                value={ward?.filter(
                                    (option: any) => data?.wards_code?.code == option.value
                                )}
                                options={ward}
                            ></Select>
                        </FormGroup>
                    </Col>
                    <Col md={from == 'exam' ? 12 : 3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label><span>*</span>Địa chỉ chi tiết</Label>
                            <Input type="text" value={data?.street} onChange={(e: any) => handleChangeInput(e)} name="street" placeholder="Nhập địa chỉ chi tiết" />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label>Email</Label>
                            <Input type="text" value={data?.email} onChange={(e: any) => handleChangeInput(e)} name="email" placeholder={(type=='view' && !data?.email) ? "---" : "Nhập Email"} />
                        </FormGroup>
                    </Col>
                    <Col md={3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label>Mã số thuế</Label>
                            <Input type="text" value={data?.tax_code} onChange={(e: any) => handleChangeInput(e)} name="tax_code" placeholder={(type=='view' && !data?.email) ? "---" : "Nhập mã số thuế"} />
                        </FormGroup>
                    </Col>
                    <Col md={3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label>Tên công ty</Label>
                            <Input type="text" value={data?.company_name} onChange={(e: any) => handleChangeInput(e)} name="company_name" placeholder={(type=='view' && !data?.email) ? "---" : "Nhập tên công ty"} />
                        </FormGroup>
                    </Col>
                    <Col md={3} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label><span>*</span>Trạng thái</Label>
                            {
                                type != 'view' ?
                                <div style={{marginTop:10}}>
                                    <ToggleButton elmChecked={data?.status == 1 ? true : false} data={data} setData={(data:any) => setData(data)} name='status' />
                                </div> :
                                <ValueText className={data?.status == 1 ? 'text-success' : "text-danger"}>{data?.status == 1 ? 'Đang hoạt động' : "Ngưng hoạt động"}</ValueText>
                            }
                        </FormGroup>
                    </Col>
                    
                </Row>
                {
                    type == 'view' &&
                    <Row>
                        <Col md={3} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Người tạo</Label>
                                <ValueText>{data?.created_uid?.name}</ValueText>
                            </FormGroup>
                        </Col>
                        <Col md={3} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Ngày tạo</Label>
                                <ValueText>{moment(data?.created_time).format("HH:mm:ss DD/MM/YYYY")}</ValueText>
                            </FormGroup>
                        </Col>
                    </Row>
                }
                
            </PageBody>
            {type === 'view' && <SupplierTab {...props} {...data}  handleChangeInput={handleChangeInput} />}
            {
                // !from &&
                <div className="bottom-action">
                    <Button color="success" className='success-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                    {
                        !id && <Button color="success" className='ml-2' onClick={handleSubmit}>Lưu</Button>
                    }
                    {
                        id && type == 'view' &&
                        <>
                            {data?.status == 1 && <Button color="success" className='danger-bland ml-2' onClick={() => props?.handleActionModal({data: data})}>Xóa</Button>}
                            <Button color="success" className='ml-2' onClick={() => router?.push(`/supplier/${id}`)}>Chỉnh sửa</Button>
                        </>
                    }
                    {
                        id && type != 'view' &&
                        <Button color="success" className='ml-2' onClick={handleEdit}>Lưu</Button>
                    }
                </div>
            }
            
            {loading && <Loader />}
        </PageContent>
    )
}

const RelativeComponent = (props:any) => {
    const {relaIndex, rela,onChangeData, data, type, onlyView, handleRemoveData, handleAddData} = props
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        if(name == 'name') {
            if(value?.length > 200) return
        }
        onChangeData({
            ...data,
            [name]: value
        })
    }

    console.log("keyxx", rela, relaIndex);
    
    return (
        <Row key={relaIndex}>
            <Col md={3} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Tên người thân</Label>
                    <Input type="text" value={data?.name} onChange={(e: any) => handleChangeData(e)} name="name" 
                    placeholder={(type=='view' && !data?.name) ? "---" : "Nhập tên người thân"} 
                    />
                </FormGroup>
            </Col>
            <Col md={3} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Quan hệ</Label>
                    <Select
                        placeholder={(type=='view' && !data?.relationship) ? "---" : "Chọn quan hệ"}
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        menuPlacement='top'
                        isDisabled={onlyView}
                        onChange={(val: any) => {
                            onChangeData({
                                ...data,
                                relationship: val?.value
                            })
                        }}
                        value={RelationList?.filter(
                            (option: any) => data?.relationship == option.value
                        )}
                        options={RelationList}
                    ></Select>
                </FormGroup>
            </Col>
            <Col md={3} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Số điện thoại</Label>
                    <InputGroup>
                        <Input type="text" value={data?.phone} onChange={(e: any) => handleChangeData(e)} name="phone" 
                        placeholder={(type=='view' && !data?.phone) ? "---" : "Nhập số điện thoại"}
                        />
                        {
                            type!='view' &&
                            <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                <img src={PhoneImageIcon} width={18} height={18} alt=""/>
                            </InputGroupAddon>
                        }
                    </InputGroup>
                </FormGroup>
            </Col>
            {
                type!='view' &&
                <Col md={3} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label></Label>
                        {
                            rela?.length == relaIndex+1 ?
                            <Button onClick={handleAddData} className='nutri-square' color='success'><i className='uil-plus'></i></Button> :
                            <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                        }
                    </FormGroup>
                </Col>
            }
            
        </Row>
    )
}

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData } = props
    const router=useHistory()
    
    const handleDelete = async() => {
        setLoading(true)
        const url = `${baseUrl}/supplier/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa nhà cung cấp thành công!')
            closeModal()
            router?.push('/supplier/list')
        }
    }

    const handleStop = async() => {
        setLoading(true)
        const url = `${baseUrl}/branch/${action?.data?.id}`;
        const params = {
            status: 0,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Ngừng hoạt động nhà cung cấp thành công')
            closeModal();
            loadData()
        }
    }

    return (
        <CardBody className='p-0' style={{width:400}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    Thông báo
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="p-3 pt-4 text-center">Bạn có chắc chắn muốn xóa nhà cung cấp <br /> <b className='text-danger'>{action?.data?.name}</b></div>
            <div className="modal-body pt-2 pb-2">
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {action?.type === 'delete' ?
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn xoá yêu cầu này?<br/> Hành động này không thể hoàn tác</p>
                            :action?.type === 'delete_list' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>{`Bạn có chắc chắn xoá ${action?.data?.length} yêu cầu này?`}<br/> Hành động này không thể hoàn tác</p>
                        }
                    </FormGroup>
                </Col>
            </div>
            <div className="modal-footer">
                <Button
                    onClick={closeModal}
                    className="ml-2 success-bland" color="success" type="button"
                > Hủy bỏ</Button>
                <Button
                    onClick={handleDelete}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}

const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

export default connect(mapState)(List)